var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNigeriaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2190_512)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2190_512",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3738 10.0006C19.3738 12.4872 18.386 14.8719 16.6277 16.6301C14.8694 18.3884 12.4847 19.3762 9.99816 19.3762C7.51159 19.3762 5.12688 18.3884 3.36861 16.6301C1.61034 14.8719 0.622559 12.4872 0.622559 10.0006C0.622559 7.51404 1.61034 5.12932 3.36861 3.37105C5.12688 1.61278 7.51159 0.625 9.99816 0.625C12.4847 0.625 14.8694 1.61278 16.6277 3.37105C18.386 5.12932 19.3738 7.51404 19.3738 10.0006Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2190_512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3745 19.375H13.1245L13.1245 0.625H19.3745L19.3745 19.375Z",
    fill: "#008753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1245 19.375H6.8745L6.8745 0.625H13.1245L13.1245 19.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87451 19.375H0.624497L0.624497 0.625H6.87451L6.87451 19.375Z",
    fill: "#008753"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2190_512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeriaIcon);
export default __webpack_public_path__ + "static/media/nigeria-icon.e43ebff301cb8f519bd88a0637be93e9.svg";
export { ForwardRef as ReactComponent };